import React, { Component, PropTypes } from 'react'
import CSSModules from 'react-css-modules'
import config from 'config'
import {Row, Col} from 'react-flexbox-grid'
import {
  DonateBanner,
  Works,
  Link,
  LinkIcon,
  FamilyGrid,
  BenchmarkGrid,
  TargetDateGrid,
  SocialButtons,
  TobaccoSectors,
  PartnerSites,
  GetStartedInput,
  AutocompleteSearch,
  SrOnly,
  // XsBr
  AykCtaPanel,
} from '../../components'
import format from '../../helpers/format'
// import {TwitterButton,EmailButton, FacebookButton} from 'react-social'
import analytics from '../../helpers/analytics'
import Loader from 'react-loader'
import ReactPlayer from 'react-player'
// import greenInactive from '../../../static/images/icn-oil-green-inactive.svg'

const Styles = require('./Home.css')

@CSSModules(Styles, {allowMultiple:true})
export default class Home extends Component {
  constructor() {
    super()
    this.state = {}
  }

  componentWillMount() {
    if (typeof window !== 'undefined') {
      window.scrollTo(0,0)
    }
  }

  renderCompanies = () => {
    return config.familyFunds.map((company,idx) =>{
      return this.renderCompany(idx,company.name,company.t_all_asset, company.rating)
    })
  }

  renderCompany = (idx,title,asset,rating) => {
    const titleURI = encodeURIComponent(title)
    return(
      <Col key={idx} styleName='companies-box-wrap' xs={12} sm={4}>
        <Link
          onMouseEnter={this.onMouseEnter('company-'+idx)}
          onMouseLeave={this.onMouseLeave('company-'+idx)}
          log={analytics.eventToFamily(title)}
          to={config.routes.families+'?q='+titleURI}
          styleName='companies-link'
          title={title}>
          <div styleName={'companies-box-'+rating}>
            <div styleName='box-title-wrapper'>
              <div styleName='box-title'>{title}</div>
            </div>
            <div styleName='box-subtitle'> {format.money(asset)} in Tobacco and Studios</div>
            <div styleName='learn-more-wrap'>
              <div styleName={'learn-more-'+rating}> Learn more<LinkIcon /></div>
            </div>
          </div>
        </Link>
      </Col>
    )
  }

  render() {
    const link = config.domain
    const message = config.shareMessage

    const aysLogo = require( '../../../static/images/AsYouSow_Logo_color.svg' )
    const ucsfSmokeFreeMoviesLogo = require( '../../../static/images/ucsf-smokefreemovies-logo.png' )
    const ucsfTobaccoLogo = require( '../../../static/images/ucsf-tobacco-logo.png' )
    const comcastIcon = require( '../../../static/images/icn-comcast-200.png' )
    const foxIcon = require( '../../../static/images/icn-fox-200.png' )
    const sonyIcon = require( '../../../static/images/icn-sony-200.png' )
    const warnerbrothersIcon = require( '../../../static/images/icn-timewarner-200.png' )
    const viacomIcon = require( '../../../static/images/icn-viacom-200.png' )
    const indiesIcon = require( '../../../static/images/icn-indies-200.png' )

    return (
      <div styleName='main'>
        <div styleName='banner-wrapper'>
          <div styleName='banner-container'>
            <div styleName='banner-container-inner'>
              <div styleName='banner-title'>
                Are your savings going up in smoke?
              </div>
              <div styleName='banner-btn-wrap'>
                <div styleName='banner-tagline'>
                  Find mutual funds and ETFs that avoid investments in tobacco companies and entertainment companies that promote smoking
                </div>
                <Link
                  to={config.routes.clean}
                  bigbutton={true}
                  title='Top-scoring funds'>
                  <div>
                    Top-scoring funds<LinkIcon />
                  </div>
                </Link>
              </div>
              <div styleName='banner-tagline'>
                Search for funds from your 401(k), retirement plan, or personal portfolio
              </div>
              <AutocompleteSearch />
              <div styleName='banner-btn-wrap'>
                <div styleName='logo-tagline'>A project of</div>
                <Link to={config.links.ays} title='As You Sow'>
                  <img
                    styleName={'logo-ays'}
                    src={aysLogo}
                    alt='As You Sow'
                  />
                  <SrOnly>As You Sow</SrOnly>
                </Link>
              </div>
            </div>
          </div>
        </div>

        <AykCtaPanel />
        
        <div styleName='x-lede'>
          <div styleName='x-lede-inner'>
            <div styleName='x-lede-title'>Making kid-rated movies smokefree would save over 1,000,000 lives</div>
            <div styleName='x-lede-subtitle'></div>
            <div styleName='x-lede-info-photo'>
              <div
                styleName='x-lede-photo'
                title="Warning: Watching movies with smoking poses a risk to your child's health"
              />
              <div styleName='x-lede-info'>
                <p styleName='x-lede-top'>
                  <strong>Invest your values.</strong> Are your savings invested in the tobacco industry or in entertainment companies that promote tobacco use?
                </p>
                <p>
                  <strong>Why tobacco is important.</strong> Smoking is the leading cause of preventable death in the U.S. and around the world. Most smokers start before they’re 18. <Link to={config.links.cdc} xstrong={true} title='CDC: Youth and Tobacco Use'>Every day, more than 2,000 young Americans become daily smokers.</Link>
                </p>
                <p>
                <strong>Many entertainment companies promote smoking.</strong> Kid-rated movies still depict smoking, even though the U.S. Surgeon General and the scientific community have concluded that smoking scenes in movies cause young people to smoke.
                </p>
              </div>
            </div>
            <div styleName='x-lede-vid-wrap'>
              { /* <div styleName='x-lede-vid-title'>Watch our video introduction</div> */ }
              <div styleName='x-lede-vid'>
                <ReactPlayer
                  url='https://vimeo.com/236527794'
                  volume={0.7} />
              </div>
              <div styleName='x-camera-img' />
            </div>
            <div styleName='x-lede-title'>Entertainment companies are recruiting young smokers</div>
            <div styleName='x-lede-subtitle'>Making kid-rated movies smokefree would save millions of kids’ lives</div>
          </div>
        </div>
        <TobaccoSectors/>
        <div styleName='x-takeaction'>
          <div styleName='x-takeaction-inner'>
            <div styleName='x-takeaction-info-photo'>
              <div styleName='x-takeaction-photo' title='Tell Hollywood to make kid-rated movies smokefree'/>
              <div styleName='x-takeaction-info'>
                <div styleName='x-takeaction-info-title'>Tell Hollywood to make kid-rated movies smokefree</div>
              <div styleName='x-takeaction-info-subtitle'>America’s best-known entertainment companies have delivered millions of American kids to the tobacco industry</div>
                <div styleName='x-takeaction-info-take-action'><Link to={config.links.speakout} bigbutton={true} title='Take action: Tell Hollywood to take smoking out of kid-rated movies!'>Take action&nbsp;<i className='fa fa-angle-double-right' /></Link></div>
              </div>
            </div>
          </div>
        </div>
        <div styleName='x-investing'>
          <div styleName='x-investing-inner'>
            <div styleName='x-investing-title'>Is tobacco harmful to your finances?</div>
            <div styleName='x-investing-subtitle'>Screen your portfolio for tobacco companies and entertainment companies that promote tobacco</div>
            <div styleName='x-investing-info-photo'>
              <div styleName='x-investing-photo' title='Screen your mutual funds for tobacco companies and entertainment companies that promote tobacco'/>
              <div styleName='x-investing-info'>
                <p styleName='x-investing-top'>
                  Most retirement savings are in 401k plans offered by our employers. 401k plans mostly offer mutual funds, and it can be hard to find out what companies are inside those funds.
                </p>
                <p>
                <strong>Use Tobacco Free Funds to X-ray your investment funds.</strong>
                </p>
                <p>
                 Tobacco Free Funds will tell you if your retirement money is invested in tobacco companies and entertainment companies that promote tobacco. We help you find investment options that support a cleaner and healthier future.
                </p>
                <Link
                  to={config.routes.about}
                  title='About Tobacco Free Funds'
                >
                  <div styleName='link-style'>
                    Your savings can change the world<LinkIcon />
                  </div>
                </Link>
              </div>
            </div>
          </div>
        </div>
        <DonateBanner />
        <div styleName='x-testimonials'>
          <div styleName='x-testimonials-inner'>
            <div styleName='x-testimonials-title'>Smoking in movies? See for yourself</div>
            <div styleName='x-testimonials-subtitle'>Click a logo below to view the tobacco footprints of America&rsquo;s best-known entertainment companies</div>
            <div styleName='hover-icon-row'>
              <Link to={config.links.comcast} title='Comcast | UCSF Smoke Free Movies'><img styleName='hover-icon' src={comcastIcon} alt='Comcast | UCSF Smoke Free Movies'/></Link>
              <Link to={config.links.fox} title='Fox | UCSF Smoke Free Movies'><img styleName='hover-icon' src={foxIcon} alt='Fox | UCSF Smoke Free Movies'/></Link>
              <Link to={config.links.sony} title='Sony | UCSF Smoke Free Movies'><img styleName='hover-icon' src={sonyIcon} alt='Sony | UCSF Smoke Free Movies'/></Link>
              <Link to={config.links.timeWarner} title='Warner Brothers - TimeWarner | UCSF Smoke Free Movies'><img styleName='hover-icon' src={warnerbrothersIcon} alt='Warner Brothers - TimeWarner | UCSF Smoke Free Movies'/></Link>
              <Link to={config.links.viacom} title='Viacom - Paramount | UCSF Smoke Free Movies'><img styleName='hover-icon' src={viacomIcon} alt='Viacom - Paramount | UCSF Smoke Free Movies'/></Link>
              <Link to={config.links.independents} title='Indies | UCSF Smoke Free Movies'><img styleName='hover-icon' src={indiesIcon} alt='Indies | UCSF Smoke Free Movies'/></Link>
            </div>
            <div styleName='x-testimonials-info-photo'>
              <div styleName='x-testimonials-photo' title='Percentage of Top-Grossing Youth-Rated Movies with Smoking'/>
              <div styleName='x-testimonials-info'>
                <p styleName='x-testimonials-top'>Breathe California and the University of California, San Francisco, maintain the world&rsquo;s largest database of on-screen tobacco, covering more than 2,750 U.S. films since 2002. You now have direct online access to the tobacco-promotion track records for every major player in every top-grossing Hollywood film for the last fifteen years and more.</p>
                <p>Survey Hollywood&rsquo;s tobacco trends. Check out tobacco rankings for producers, directors, actors, and other famous names. Compare the tobacco footprints of America&rsquo;s biggest entertainment companies. Call up individual movie reports. And investigate the Hollywood&rsquo;s long history of collaborating with tobacco companies to sell smoking to new audiences, traced in once-secret industry documents.</p>
                <p>Who&rsquo;s accountable for putting toxic tobacco imagery in the movies that kids see most? Get the facts.</p>
                <Link
                  to={config.links.ucsfDatabase}
                  title='UCSF Smoke Free Movies Database'
                >
                  <div styleName='link-style'>
                    UCSF Smoke Free Movies Database<LinkIcon />
                  </div>
                </Link>
              </div>
            </div>
            <div styleName='x-testimonials-icons'>
              <div styleName='x-testimonials-icons-info'>
                <em>Smoke Free Movies Database is a public resource provided by:</em>
              </div>
              <img
                styleName='x-testimonials-icon'
                src={ucsfTobaccoLogo}
                alt='UCSF Center for Tobacco Control Research and Education'
              />
              <img
                styleName='x-testimonials-icon'
                src={ucsfSmokeFreeMoviesLogo}
                alt='UCSF Smoke Free Movies'
              />
            </div>
          </div>
        </div>
        <Works/>
        <GetStartedInput />
        <div styleName='_container'>
          <div styleName='_container-inner'>
            <PartnerSites />
          </div>
        </div>
      </div>
    )
  }
}

